import { getAuthHeaders, handleAuthError } from './authUtils';

const API_ORIGIN = process.env.REACT_APP_API_URL || 'http://localhost:5001';
const API_BASE_URL = `${API_ORIGIN}/api`;

async function parseResponse(response, fallback) {
  if (!response.ok) {
    if (response.status === 401) {
      handleAuthError();
      return fallback;
    }
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `HTTP error! status: ${response.status}`);
  }
  return response.json();
}

class FlowStatusApiService {
  async getRuns({ service, status, page = 1, limit = 10 } = {}) {
    const params = new URLSearchParams();
    if (service) params.set('service', service);
    if (status) params.set('status', status);
    params.set('page', String(page));
    params.set('limit', String(limit));

    const response = await fetch(`${API_BASE_URL}/flow-status/runs?${params.toString()}`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return parseResponse(response, { success: false, data: [], pagination: {} });
  }

  async getRun(id) {
    const response = await fetch(`${API_BASE_URL}/flow-status/runs/${id}`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return parseResponse(response, { success: false, data: null });
  }

  async retryStep(stepId) {
    const response = await fetch(`${API_BASE_URL}/flow-status/steps/${stepId}/retry`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return parseResponse(response, { success: false });
  }

  async holdStep(stepId, reason) {
    const response = await fetch(`${API_BASE_URL}/flow-status/steps/${stepId}/hold`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify({ reason })
    });
    return parseResponse(response, { success: false });
  }
}

export const flowStatusApi = new FlowStatusApiService();
